import { render, staticRenderFns } from "./chooseBusinessPriceDetail.vue?vue&type=template&id=e27dfc94&scoped=true"
import script from "./chooseBusinessPriceDetail.vue?vue&type=script&lang=js"
export * from "./chooseBusinessPriceDetail.vue?vue&type=script&lang=js"
import style0 from "./chooseBusinessPriceDetail.vue?vue&type=style&index=0&id=e27dfc94&prod&lang=scss"
import style1 from "./chooseBusinessPriceDetail.vue?vue&type=style&index=1&id=e27dfc94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27dfc94",
  null
  
)

export default component.exports